import type {
    Account,
    AccountId,
    Address,
    AssignableId,
    ContactId,
    CustomFieldAttribute,
    Email,
    FileId,
    FollowupId,
    JsonApiLink,
    Phone,
    TagId,
    TaskId,
    TerritoryId,
    Url,
    UrlString,
    UserId,
} from '../types';
import type {EavValue} from '../eav/types';

import type {State as ContactsState} from './contacts-reducer';

export const REDUCER_KEY = 'contacts';
export type ReducerKey = 'contacts';

export type ContactsModuleState = Partial<Record<ReducerKey, ContactsState>>;

type Job = Partial<
    Record<
        AccountId,
        {
            title: string;
        }
    >
>;

type ContactLinks = {
    accounts: AccountId[];
    creator: UserId;
    owner: AssignableId | null | undefined;
    territory: TerritoryId | null | undefined;
    tags: TagId[];
    files: FileId[];
    followup: FollowupId | null | undefined;
    recurringTask: TaskId | null | undefined;
};

type BaseContact = {
    id: ContactId;
    type: 'contacts';
    name: string;
    description?: string | null | undefined;
    jobs: Job[];
    jobTitle: string;
    avatarUrl: UrlString;
    initials: string;
    htmlUrl: UrlString;
    links: ContactLinks;
};

// TODO: This should probably be lifted to a higher context if we begin using
// on accounts or leads
export type CustomFieldValue =
    | string
    | number
    | {
          currencyShortname: string;
          amount: number | null | undefined;
          formatted?: string;
      };
export type EditableContact = BaseContact & {
    emails: EavValue[];
    addresses: EavValue[];
    phones: EavValue[];
    urls: EavValue[];
    customFields?: {
        [key: string]: CustomFieldValue | null | undefined;
    };
};

export type Contact = any;

// Responses from /rest/contacts
export type ContactsApiResponse = {
    meta: {
        count?: number;
        total?: number;
    };
    links:
        | {
              [key: string]: JsonApiLink;
          }
        | [];
    contacts: Contact[];
    accounts?: Account[];
};

export type ContactCreationFormValues = {
    id?: string;
    name?: string;
    description?: string | null | undefined;
    links?: {
        accounts: AccountId[];
    };
    emails?: EavValue[];
    phones?: EavValue[];
    addresses?: EavValue[];
    urls?: EavValue[];
    customFields?: {
        [key: string]: CustomFieldValue | null | undefined;
    };
};
